import { render, staticRenderFns } from "./SetDiscount.vue?vue&type=template&id=775e7504"
import script from "./SetDiscount.vue?vue&type=script&lang=js"
export * from "./SetDiscount.vue?vue&type=script&lang=js"
import style0 from "./SetDiscount.vue?vue&type=style&index=0&id=775e7504&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports